export class TrackShuttleCounter
{
  shuttleStatus: string;
}